import { gsap } from 'gsap'
import { TextReveal } from '../../../modules/text-reveal'

function instant(ctx) {
	// gsap.set(ctx.container, { clearProps: 'all' })
	return null
}

function swup(ctx) {
	// return gsap.from(ctx.container, {
	// 	opacity: 0,
	// 	y: 12,
	// 	duration: 0.4,
	// })
	return null
}

function normalReveal(ctx) {
	const elTitle = ctx.container.querySelector('.page-header h1')
	const elImage = ctx.container.querySelector('.js-image-grid-reveal-source')

	const textReveal = new TextReveal(elTitle, {
		trigger: false,
		manualReveal: true,
	})

	const revealTl = gsap.timeline({ delay: 0.3 })

	revealTl
		.add(() => {
			textReveal.reveal()
		})
		.fromTo(
			elImage,
			{ scale: 0.8, opacity: 0 },
			{
				opacity: 1,
				scale: 1,
				y: 0,
				duration: 1.2,
				ease: 'power4.out',
			},
			'+=0.2'
		)
}

export default {
	direct: normalReveal,
	swup: normalReveal,
	history: instant,
}
